import React from "react";
import { ProductCard } from "../ProductCard/ProductCard";
import { Link } from "react-router-dom";
import FlickitySlider from "../FlickitySlider/FlickitySlider";
import { useQuery } from "@apollo/react-hooks";
import { RECOMMENDED_PRODUCTS } from "../../queries/recommandedQuery";
import "./RecommendedProducts.scss";

const RecommendedProducts = (props) => {
  const bannerImage = props.bannerImage;
  const bannerLink = props.bannerLink;

  const { data, loading, error } = useQuery(RECOMMENDED_PRODUCTS, {
    variables: { limit: 8 },
  });

  if (loading) return <div></div>;
  if (error) return <div></div>;

  const products = data?.products?.nodes || [];

  return (
    <div className="RecommendedProducts">
      <p className="RecommendedProducts__title">{props.title}</p>
      <div className="RecommendedProducts__content">
        <Link to={bannerLink} className="banner">
          <img className="banner-image" src={bannerImage} alt="" />
        </Link>
        <div className="slider-wrapper">
          <FlickitySlider productInFocus={true} options={{ freeScroll: true, contain: true, wrapAround: false, groupCells: true, prevNextButtons: true, pageDots: false }}>
            {products.map((product) => <ProductCard productFocus={true} key={product.id} product={product} />)}
          </FlickitySlider>
        </div>
      </div>
    </div>
  );
};

export default RecommendedProducts;
